module.exports = __webpack_public_path__ + "img/Facebook_black.75fd7d6b.svg";